<div class="errorPage-container">
    <div class="error-page">
        <div class="error-page-content">
            <h1>{{ 'OS_VERSION_NOT_SUPPORTED' }}</h1>
            <p>{{ 'OS_VERSION_NOT_SUPPORTED_DESCRIPTION' | translate: {value: windowVersion} }}</p>
        </div>
    </div>
</div>
